import Service from '../../balancer-farm-subgraph.service';
import queryBuilder from './query';
import { UserLeaveRequests, QueryBuilder } from '../../types';

export default class userLeaveRequests {
  service: Service;
  query: QueryBuilder;

  constructor(service: Service, query: QueryBuilder = queryBuilder) {
    this.service = service;
    this.query = query;
  }

  public async get(args = {}, attrs = {}): Promise<UserLeaveRequests[]> {
    const query = this.query(args, attrs);
    const data = await this.service.client.get(query);
    return data && data.userLeaveRequests ? data.userLeaveRequests : [];
  }
}
